import React, { useState } from "react";
import { Typography, Box, Container, TextField, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { useResetPassword } from "../../components/HandlingComponents";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [reqSent, setReqSent] = useState(false);
  const resetPassword = useResetPassword();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    resetPassword.mutate(email);
    setReqSent(true);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            onChange={handleEmailChange}
            fullWidth
            id="email"
            label="Indirizzo email"
            name="email"
            autoFocus
          />
          {reqSent ? (
            <Typography>
              Richiesta inviata! Ora puoi tornare alla pagina di{" "}
              <Link to={"/login"}>login</Link>
            </Typography>
          ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Richiedi reset della password
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default ResetPassword;
